const middleware = {}

middleware['getLocaleNavigation'] = require('../middleware/getLocaleNavigation.js')
middleware['getLocaleNavigation'] = middleware['getLocaleNavigation'].default || middleware['getLocaleNavigation']

export default middleware
